export enum DxListFeatureFlag {
  /** Controls whether the Dx List module shows */
  SHOW_DX_LIST = 'growth-public-site-show-common-causes-module',
}
